











import Vue from 'vue'
import { range } from '@/utils/helper'
import Button from '@/components/shared/atoms/Button/Button'
import Select, { SelectOption } from '@/components/shared/atoms/Select'

export default Vue.extend({
  components: {
    Button,
    Select
  },
  props: {
    totalPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    pages(): SelectOption[] {
      if (this.totalPage === 1)
        return [
          {
            value: '1',
            text: '1'
          }
        ]

      return range(1, this.totalPage).map(page => ({
        value: String(page),
        text: String(page)
      }))
    }
  },
  methods: {
    handlePrev() {
      this.$emit('change', this.currentPage - 1)
    },
    handleNext() {
      this.$emit('change', this.currentPage + 1)
    },
    handleChange(val: number) {
      this.$emit('change', val)
    }
  }
})
